import { ModelInstance, ToBackHook, ToFrontHook } from './util';
import { File } from './file';

@ModelInstance({
  mappingFields: {
    id: 'id',
    theme: 'theme',
    message: 'message',
    files: 'files',
    email: 'email',
    captcha: 'captcha',
  },
  relation: {
    files: File
  }
})
export class Feedback {
  id: number;
  theme: string;
  message: string;
  email: string;
  captcha: string;
  files: File[];

  @ToFrontHook
  static toFront(data: any): any {
    return null;
  }

  @ToBackHook
  static toBack(value: any): any {
    return null;
  }
}
